import { render, staticRenderFns } from "./CatePreview.vue?vue&type=template&id=5e12166d&scoped=true&"
import script from "./CatePreview.vue?vue&type=script&lang=js&"
export * from "./CatePreview.vue?vue&type=script&lang=js&"
import style0 from "./CatePreview.vue?vue&type=style&index=0&id=5e12166d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12166d",
  null
  
)

export default component.exports